import { c as _c } from "react/compiler-runtime";
import classNames from '@/utils/classNames';
const baseClassName = ['size-6', 'shrink-0', 'flex', 'items-center', 'justify-center', 'cursor-pointer'].join(' ');
export type IconContainerType = 'button' | 'span';
export type IconContainerProps<T extends IconContainerType> = {
  as?: T;
} & React.ComponentPropsWithoutRef<T>;
const IconContainer = t0 => {
  const $ = _c(12);
  let as;
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      as,
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = as;
    $[2] = children;
    $[3] = className;
    $[4] = props;
  } else {
    as = $[1];
    children = $[2];
    className = $[3];
    props = $[4];
  }
  const Component = as || "button";
  let t1;
  if ($[5] !== className) {
    t1 = classNames(baseClassName, className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== Component || $[8] !== children || $[9] !== props || $[10] !== t1) {
    t2 = <Component className={t1} {...props}>{children}</Component>;
    $[7] = Component;
    $[8] = children;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};
export default IconContainer;